<template>
  <div class="table-box">
    <mf-loading :loader="['last-update', 'primeiro-registro', 'produtos-mais-clientes-top']" loader-type="table">
      <v-container fluid grid-list-md>
        <v-layout>
          <v-flex v-for="(card, index) in cards" :key="index" xs4>
            <cbm-card
              :number-text="card.value"
              :title="card.text"
              unset-percentage-colors
              simple-card
              :percent-text="card.underText"
              :loader="card.loader"
              :is-integer="card.isInteger"
            />
          </v-flex>
        </v-layout>
      </v-container>
      <v-data-table :headers="headers" :items="dadosTabela" hide-default-footer disable-pagination @current-items="updateSelectedItems">
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.index }}</td>
            <td>
              <router-link class="link" :to="{ path: `/produtos/detalhes-produto/${item['COD_ID_PRODUTO']}` }">
                {{ item['COD_ID_PRODUTO'] }} - {{ item['DES_PRODUTO'] }}
              </router-link>
            </td>
            <td class="text-right">{{ item['NUM_CUPONS_TOTAL'] | localeString }}</td>
            <td class="text-right">{{ item['VAL_FATURAMENTO_TOTAL'] | localeString(2) | currency }}</td>
            <td class="text-right">{{ item['NUM_CLIENTES_TOTAL'] | localeString }}</td>
            <td class="text-right">{{ item['VAL_QUANTIDADE_KG_TOTAL'] | localeString(1) }}</td>
            <td class="text-right">{{ item['PORCENTAGEM'] | abreviation | percent }}</td>
          </tr>
        </template>
      </v-data-table>
    </mf-loading>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import { mapGetters } from 'vuex'
import { porcentagemProduto, localeString } from '@/config/helpers.js'
import CbmCard from '@/components/CbmCard.vue'
import { mapWaitingActions } from 'vue-wait'
import { productRanking } from '@/modules/produtos/ranking-produtos/mixins/productRanking'

export default {
  components: {
    CbmCard,
  },
  mixins: [productRanking],
  computed: {
    ...mapGetters(['produtosTopMaisClientes', 'produtosTotalClientes', 'produtosTotalTopClientes', 'produtosSkuAtivasVendas']),
    dadosTabela() {
      return cloneDeep(this.produtosTopMaisClientes).map((object, index) => {
        object['PORCENTAGEM'] = porcentagemProduto(object['NUM_CLIENTES_TOTAL'], this.produtosTotalClientes)
        object.index = index + 1
        return object
      })
    },
    topClientesPorcentagem() {
      return `${localeString((this.produtosTotalTopClientes / this.produtosTotalClientes) * 100, 1)} %`
    },
    cards() {
      return [
        {
          text: 'Total de clientes ativos no período',
          value: this.produtosTotalClientes,
          underText: '100 %',
          loader: 'totais-clientes-produtos',
          isInteger: true,
        },
        {
          text: 'Clientes com os 100 produtos com mais presença em clientes',
          value: this.produtosTotalTopClientes,
          underText: this.topClientesPorcentagem,
          loader: 'totais-clientes-produtos-top',
          isInteger: true,
        },
        {
          text: 'Produtos distintos vendidos no período',
          value: this.produtosSkuAtivasVendas,
          loader: 'totais-clientes-produtos',
          isInteger: true,
        },
      ]
    },
  },
  methods: {
    ...mapWaitingActions({
      totaisClientesProdutos: 'totais-clientes-produtos',
      totaisClientesProdutosTop: 'totais-clientes-produtos-top',
      produtosMaisClientesTop: 'produtos-mais-clientes-top',
    }),
    internalGetData(filter) {
      return [this.totaisClientesProdutos(filter), this.totaisClientesProdutosTop(filter), this.produtosMaisClientesTop(filter)]
    },
  },
}
</script>
